// extracted by mini-css-extract-plugin
export default {"description":"style_description__xTS7d","descriptionContainer":"style_descriptionContainer__jkI0d","vignette":"style_vignette__hEiDL"};